define('app/dashboard/panels/DecisionDashboardPanel',['require','./DashboardPanel','glu/util','hbs!./DecisionDashboardPanel.hbs'],function(require) {

	'use strict';
	var DashboardPanel = require('./DashboardPanel'),
		_ = require('glu/util');

	return DashboardPanel.extend({
		template: require('hbs!./DecisionDashboardPanel.hbs'),

		ui: function() {
			return _.extend(DashboardPanel.prototype.ui, {
				$topContainer: '.top-container',
				$bottomLeftContainer: '.bottom-left-container',
				$bottomRightContainer: '.bottom-right-container',
				decisionWidgets: '#dashboard-tab-my-widgets'
			});
		},

		/**
		 * My reports and others tabs do not exist with this dashboard panel.
		 */
		addViews: function() {

		},

		/**
		 * Disable drag and drop for this dashboard panel.
		 */
		enableDragAndDrop: function() {

		},


		/**
		 * Determine the best location for the widget.  For now we have to use the widget name to determine
		 * the best location.  In the future we may want to add something to the report model to make this less fragile.
		 */
		addWidget: function(view, model, selector) {
			var widgetName = model.get('name');

			var $renderedEl = view.render().$el;

			$renderedEl.attr('data-qa', model.get('name'));

			switch (widgetName) {
				// Request decisions
				case 'Total Requests':
					this.ui.decisionWidgets.find('.donut-container .wrap-top .col1 .top').append($renderedEl);
					break;
				case 'Completed Requests':
					this.ui.decisionWidgets.find('.donut-container .wrap-top .col1 .bottom').append($renderedEl);
					break;
				case 'Auto-Declined':
					this.ui.decisionWidgets.find('.donut-container .wrap-top .col2').append($renderedEl);
					break;
				case 'KBA Declined':
					this.ui.decisionWidgets.find('.donut-container .wrap-top .col3').append($renderedEl);
					break;

					// Application decisions
				case 'Submitted Applications':
					this.ui.decisionWidgets.find('.donut-container .wrap-bottom .col1 .top').append($renderedEl);
					break;
				case 'Commenced Applications':
					this.ui.decisionWidgets.find('.donut-container .wrap-bottom .col1 .bottom').append($renderedEl);
					break;
				case 'Manually Declined':
					this.ui.decisionWidgets.find('.donut-container .wrap-bottom .col2').append($renderedEl);
					break;
				case 'Canceled Applications':
					this.ui.decisionWidgets.find('.donut-container .wrap-bottom .col3').append($renderedEl);
					break;

					// Declines
				case 'Auto-declined vs KBA Declined':
					this.ui.decisionWidgets.find('.pie-container .col1 .top').append($renderedEl);
					break;

					// Approvals
				case 'Auto Approved vs Review':
					this.ui.decisionWidgets.find('.pie-container .col1 .bottom').append($renderedEl);
					break;

					// Third party provider reports
				case 'IP Intelligence Decisions':
					this.ui.decisionWidgets.find('.pie-container .col2 .top').append($renderedEl);
					break;
				case 'ID Verification Decisions':
					this.ui.decisionWidgets.find('.pie-container .col2 .top').append($renderedEl);
					break;
				case 'ID Authentication Decisions':
					this.ui.decisionWidgets.find('.pie-container .col2 .bottom').append($renderedEl);
					break;
				case 'Debit History Decisions':
					this.ui.decisionWidgets.find('.pie-container .col2 .bottom').append($renderedEl);
					break;

					// Top 10
				case 'Top Auto Declination Reasons':
				case 'Top Manual Declination Reasons':
					this.ui.decisionWidgets.find('.top-ten-container').append($renderedEl);
					break;
				default:
					this.ui.decisionWidgets.find(selector).append($renderedEl);
			}

			this.widgets.push(view);
		}
	});
});

